// extracted by mini-css-extract-plugin
module.exports = {"search":"Search__search___2TyO5","icon":"Search__icon___huTdp","dc":"Search__dc___3pE-M"};